import { arrayFind } from 'common/helper/array/find';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { InputSelectOptionInterface } from 'common/module/input/select/option.interface';

/**
 * Produces selected text based on selected item or items
 *
 * @param selected - selected item or items
 * @param defaultSelected - default selected text when there's no selection
 * @param options - list of options
 */
export function inputSelectProduceSelectedText(
  selected: string | string[] | undefined,
  defaultSelected: string = i18nTranslate('--select--'),
  options: InputSelectOptionInterface[]
): string {
  if (selected === undefined) {
    return defaultSelected;
  }

  if (Array.isArray(selected)) {
    if (!selected.length) {
      return defaultSelected;
    }

    if (selected.length === options.length) {
      return i18nTranslate('All selected');
    }

    if (selected.length > 1) {
      return i18nTranslate('{count} selected').replace('{count}', String(selected.length));
    }

    let text = null;

    options.forEach((option: InputSelectOptionInterface) => {
      if (option.value === selected[0]) {
        text = option.text;
      }
    });
    return text;
  }

  const foundOption = arrayFind(options, (option) => option.value === selected);
  return (foundOption && foundOption.text) || defaultSelected;
}
